import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { ButtonStyles } from '../../../../styles/button';

export const Container = styled.div`
  position: relative;
  padding: 0 50px;
  display: flex;
  align-items: center;
  background-color: ${Colors.shade07};
  justify-content: space-around;
  overflow: hidden;
  
  input[type=range] {
    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
    width: 100%; /* Specific width is required for Firefox. */
    background: transparent; /* Otherwise white in Chrome */
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  input[type=range]:focus {
    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
  }

  input[type=range]::-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
`;

export const Button = styled.button`
  ${ButtonStyles};
`;

export const ColorSlidersContainer = styled.div`
`;
